import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import hero1 from '../../assets/carousel-img/1.jpg';
import hero2 from '../../assets/carousel-img/2.jpg';
import hero3 from '../../assets/carousel-img/3.jpg';

const slides = [
  {
    id: 1,
    image: hero1,
    title: 'TIRUPATI BALAJI SHEEGRA DARSHAN',
    subtitle: 'Daily Package Trips from BANGALORE to TIRUPATI',
    tags: ['TTD', 'KSTDC', 'IRCTC', 'APTDC'],
    tagColor: '#cc0000',
  },
  {
    id: 2,
    image: hero2,
    title: 'EXPLORE INCREDIBLE INDIA',
    subtitle: 'Discover the beauty of Indian heritage and culture',
    tags: ['IRCTC', 'KSTDC', 'GOI'],
    tagColor: '#1a4a8c',
  },
  {
    id: 3,
    image: hero3,
    title: 'GOA BEACH HOLIDAY PACKAGES',
    subtitle: 'Relaxing getaways with best accommodation & transfers',
    tags: ['AC Bus', 'Hotel', 'Meals'],
    tagColor: '#1a7a4a',
  },
];

// Custom Arrow Components
const PrevArrow = ({ onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      position: 'absolute',
      left: 50,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      width: 35,
      height: 35,
      borderRadius: '50%',
      backgroundColor: '#18458b',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#1a4a8c',
        boxShadow: '0 0 0 9px rgba(255, 255, 255, 0.6)',
      },
      // Outer foggy ring with multiple layers
      boxShadow: '0 0 0 8px rgba(255, 255, 255, 0.5)',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: -2,
        left: -2,
        right: -2,
        bottom: -2,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 70%)',
        pointerEvents: 'none',
      }
    }}
  >
    <ChevronLeftIcon sx={{ color: '#fff', fontSize: 24 }} />
  </Box>
);

const NextArrow = ({ onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      position: 'absolute',
      right: 50,
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 10,
      width: 35,
      height: 35,
      borderRadius: '50%',
      backgroundColor: '#18458b',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#1a4a8c',
        boxShadow: '0 0 0 9px rgba(255, 255, 255, 0.6)',
      },
      // Outer foggy ring with multiple layers
      boxShadow: '0 0 0 8px rgba(255, 255, 255, 0.5)',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: -2,
        left: -2,
        right: -2,
        bottom: -2,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0) 70%)',
        pointerEvents: 'none',
      }
    }}
  >
    <ChevronRightIcon sx={{ color: '#fff', fontSize: 24 }} />
  </Box>
);

const HeroCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    appendDots: (dots) => (
      <Box
        sx={{
          position: 'absolute',
          bottom: 16,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', gap: 8 }}>
          {dots}
        </ul>
      </Box>
    ),
    customPaging: () => (
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: 'rgba(255,255,255,0.5)',
          cursor: 'pointer',
          '.slick-active &': { backgroundColor: '#3eb0e9' },
        }}
      />
    ),
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        '& .slick-dots': {
          bottom: 16,
          '& li button:before': { color: '#fff', fontSize: 10 },
          '& li.slick-active button:before': { color: '#3eb0e9' },
        },
      }}
    >
      <Slider {...settings}>
        {slides.map((slide) => (
          <Box key={slide.id}>
            <Box
              sx={{
                position: 'relative',
                height: { xs: 320, sm: 400, md: 500, lg: 500 },
                overflow: 'hidden',
              }}
            >
              {/* Background Image */}
              <Box
                component="img"
                src={slide.image}
                alt={slide.title}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
              />

              {/* Dark overlay */}
              {/* <Box
                sx={{
                  position: 'absolute',
                  inset: 0,
                  background:
                    'linear-gradient(to right, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.1) 60%, transparent 100%)',
                }}
              /> */}


            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default HeroCarousel;
